<template>
    <div class="check-activity">
        <img src="https://pstatic.navi-sci.cn/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250922135124_60_6.jpg" alt="" @click="handleShowQrcodeImage" />
        <!-- <div v-if="openQRcode" class="QRcode-box">
            <div class="QRcode-box-content">
                <img src="https://pstatic.navi-sci.cn/cashBack_act/pc_cashBack_QrCode_.png" alt="" />
                <i class="el-icon-close" @click="openQRcode = false"></i>
                <div v-if="!qr_loading" class="QRcode-main">
                    <img :src="QRCode_main" />
                </div>
                <div v-else v-loading="qr_loading" class="loading-box"></div>
            </div>
        </div> -->
        <el-dialog :show-close="false" id="checkActivityQrcodeDialog" :visible.sync="openQRcode" width="400px">
            <div class="content">
                <div v-if="!qr_loading" class="activity-pic">
                    <img :src="QRCode_main" />
                    <div class="activity-title">
                        <div>微信扫码</div>
                        <el-divider direction="vertical"></el-divider>
                        <div>小程序参与抽奖</div>
                    </div>
                </div>
                <div v-else v-loading="qr_loading" class="loading-box"></div>
                <div class="icon-close">
                    <i class="el-icon-circle-close" @click="openQRcode = false"></i>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getQRcode } from '@/api/request';
export default {
    name: 'checkActivity',
    data() {
        return {
            openQRcode: false,
            qr_loading: false,
            QRCode_main: '',
        };
    },
    methods: {
        handleShowQrcodeImage() {
            const {activityId} = this.$route.query;
            const url = `pages/index/index`;
            this.openQRcodeBox(url, 400, `type=goActivity&activityId=${activityId}`);
        },
        // 生成跳转小程序的二维码
        openQRcodeBox(path, width, scene) {
            this.openQRcode = true;
            this.qr_loading = true;
            getQRcode(path, width, scene).then((res) => {
                this.QRCode_main = 'data:image/png;base64,' + res.qrCodeBytes;
                this.qr_loading = false;
            });
        }
    }
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
    background-color: transparent;
    --webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
}
::v-deep .el-dialog__body {
    padding: 0;
    height: 480px;
    background-color: transparent;
}

::v-deep .el-dialog__header {
    display: none;
}
.check-activity {
    width: 100vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
        width: 50%;
        height: 66vw;
    }
}
.content {
    border-radius: 40px;
    background-color: transparent;
    overflow: hidden;
    display: flex;
    justify-content: center;
    // position: relative;
    // position: relative;
    // align-items: center;
    .activity-pic {
        padding:70px 50px 50px 50px;
        width: 300px;
        height: 300px;
        background-color: #fff;
        border-radius: 40px;
        position: relative;
        img {
            width: 100%;
            height: 100%;
        }
        .activity-title {
            position: absolute;
            top: 0;
            left: 0;
            color: #666;
            font-size: 20px;
            display: flex;
            align-items: center;
            height: 70px;
            justify-content: center;
            width: 100%;
        }
    }
    .icon-close {
        height: 50px;
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 40px;
        color: #fff;
    }
}
</style>
